import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "@material-ui/core/Button";
import { useDispatch, useSelector } from "react-redux";
import { setIdCrmAction } from "../../reducers";
import { setIdUserAction } from "../../reducers";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { KEY_ENTER } from "../../utils/constants";
import CircularProgress from "@material-ui/core/CircularProgress";
import ErrorOutlineRoundedIcon from "@material-ui/icons/ErrorOutlineRounded";
import { useIntl } from "react-intl";
import HighlightOffRoundedIcon from "@material-ui/icons/HighlightOffRounded";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    padding: theme.spacing(4, 2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
  },
  title: {
    textTransform: "upperCase",
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
  },
  buttonContainer: {
    display: "flex",
    gap: theme.spacing(2),
  },
  button: theme.classes.mainButton,
  secondaryButton: theme.classes.secondaryButton,
  error: {
    color: "red",
  },
}));

export const CustomListComponent = (props) => {
  const { title, handleSubmit, setter } = props;
  const intl = useIntl();
  const classes = useStyles();
  const dispatch = useDispatch();

  const loading = useSelector((state) => state.loading);
  const storedIdCrm = useSelector((state) => state.idCrm);
  const storedIdUser = useSelector((state) => state.idUser);
  const tenant = useSelector((state) => state.tenant);

  const handleCrmId = (value) => {
    if (!value) {
      dispatch(setIdCrmAction(""));
      dispatch(setIdUserAction(""));
    }
    dispatch(setIdCrmAction(value));
  };

  const handleUserId = (value) => {
    if (!value) {
      dispatch(setIdUserAction(""));
    }
    dispatch(setIdUserAction(value));
  };

  const handleSendForm = (event) => {
    const { key } = event;

    tenant && key === KEY_ENTER && storedIdCrm && storedIdUser && handleSubmit();
  };

  const handleEraseInfo = () => {
    dispatch(setIdCrmAction(""));
    dispatch(setIdUserAction(""));
    setter(null);
  };

  return (
    <div className={classes.pageContainer}>
      {title && (
        <Typography variant={"h4"} className={classes.title}>
          {title}
        </Typography>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} lg={2}>
          <TextField
            label={intl.formatMessage({ id: "custom.id_crm" })}
            value={storedIdCrm}
            variant="outlined"
            onChange={(e) => handleCrmId(e.target.value)}
            onKeyDown={handleSendForm}
          />
        </Grid>
        <Grid item xs={12} md={3} lg={2}>
          <TextField
            className={classes.textField}
            label={intl.formatMessage({ id: "custom.id_user" })}
            value={storedIdUser}
            variant="outlined"
            onChange={(e) => handleUserId(e.target.value)}
            onKeyDown={handleSendForm}
          />
        </Grid>
        <Grid item xs={12} md={3} lg={4} className={classes.buttonContainer}>
          <Button
            className={classes.button}
            disabled={!storedIdCrm || !storedIdUser || !tenant}
            variant="contained"
            onClick={handleSubmit}
            startIcon={<SearchRoundedIcon />}
          >
            {intl.formatMessage({ id: "ra.action.search" })}
          </Button>
          <Button
            className={classes.secondaryButton}
            onClick={handleEraseInfo}
            startIcon={<HighlightOffRoundedIcon />}
            disabled={!storedIdCrm && !storedIdUser}
          >
            {intl.formatMessage({ id: "ra.action.erase" })}
          </Button>
        </Grid>
        {loading && (
          <Grid item xs={12} md={4} lg={2}>
            <CircularProgress color="primary" />
          </Grid>
        )}
        {!tenant && (
          <Grid item xs className={classes.error}>
            <ErrorOutlineRoundedIcon />
            <Typography variant={"body2"}>{intl.formatMessage({ id: "custom.tenant.tenant_mandatory" })}</Typography>
          </Grid>
        )}
      </Grid>
    </div>
  );
};
